export const APP_NAME = 'bloomreach';

// Our own toast copy only; unreachableService = getOrg() throwing, not a 404.
export const ERROR_COPY = {
  unreachableService: 'Cannot reach the Gupshup integrations service',
  emptyTemplates: 'No approved templates on this channel',
  invalidOrgToken: 'We could not find an account for that org token. Double-check it and try again.',
  mediaUploadFailed: 'Media upload failed. Please try again, or use an image URL instead.',
  templatesLoadFailed: 'Could not load templates for this channel. Please try again.',
  restoreFailed: 'Couldn\'t load the saved message. Reopen the node to try again.',
  templateChangedSinceSave: 'This template changed since this message was saved. Review the variables and save again.',
  templateNotOnNumber: 'This template isn\'t on the selected number. Pick it again from the list.',
};

// On: every template the Standard panel can send opens in our own form, so a template switch keeps what the marketer
// typed (templateSend/registry.js, pages/Message). Off: only the kinds the shared component cannot send do.
export const LOCAL_FORM_ALL_TEMPLATES = process.env.REACT_APP_LOCAL_FORM_ALL_TEMPLATES === 'true';

// Persists the org token entered on AuthScreen so re-opening this widget inside the same
// Bloomreach webhook preset (which reloads the iframe with no orgId query param) skips it.
export const ORG_TOKEN_STORAGE_KEY = 'br-widget-org-token';

// Library components nest their own ThemeProvider; themed via overrides.css instead.
export const GUPSHUP_THEME_CONFIG = {
  typography: {
    fontFamily: 'Poppins, system-ui, sans-serif',
  },
  shape: {
    borderRadius: 6,
  },
  palette: {
    primary: { main: '#5b4ddb' },
    text: { primary: '#1c1c28', secondary: '#6b7186' },
    divider: '#e6e7ec',
    background: { default: '#ffffff', paper: '#ffffff' },
  },
  custom: {
    colors: {
      primary: { lighter: '#f1efff', lightest: '#faf9ff' },
      grey: { lighter: '#e6e7ec', lightest: '#f7f7fa' },
      accent: { lighter: '#e6e7ec' },
    },
  },
};


export const DLRColumns = [
  {
    dataType: 'string',
    id: 'programId',
    label: 'Program ID',
  },
  {
    dataType: 'string',
    id: 'templateId',
    label: 'Template ID',
  },
  {
    dataType: 'string',
    id: 'sent',
    label: 'Sent',
  },
  {
    dataType: 'string',
    id: 'delivered',
    label: 'Delivered',
  },
  {
    dataType: 'string',
    id: 'read',
    label: 'Read',
  },
  {
    dataType: 'string',
    id: 'failed',
    label: 'Failed',
  },
];

export const DLRSummaryColumns = [
  {
    dataType: 'string',
    id: 'triggered',
    label: 'Triggered',
  },
  {
    dataType: 'string',
    id: 'sent',
    label: 'Sent',
  },
  {
    dataType: 'string',
    id: 'delivered',
    label: 'Delivered',
  },
  {
    dataType: 'string',
    id: 'read',
    label: 'Read',
  },
  {
    dataType: 'string',
    id: 'failed',
    label: 'Failed',
  },
];

export const testAccounts = ['918742981694', '919289221771', '919355045189'];

// Field list only — callback/updateCallback live in AccountSettings (need org access).
export const CHANNEL_FIELDS = [
  {
    key: 'channelName',
    label: 'Channel name',
    type: 'textField',
    helperText: 'Name of your channel.',
    isRequired: true,
    isEditable: true,
  },
  {
    key: 'userId',
    label: 'HSM account ID',
    type: 'textField',
    helperText: 'The HSM account id of your Gupshup account.',
    isRequired: true,
  },
  {
    key: 'password',
    label: 'Password',
    type: 'textField',
    helperText: "The password of your Gupshup account for authentication of the userid(HSM Account password).",
    isRequired: true,
    fieldType: 'password',
    isEditable: true,
  },
  {
    key: 'whatsappNo',
    label: 'WhatsApp business number',
    type: 'textField',
    helperText:
      'The WhatsApp business number Guspshup has offered when you created the account. Enter the number and country code E.g., 91 in country code and 7834811114 in the phone number field.',
    isRequired: true,
    fieldType: 'phoneNumber',
    isEditable: true,
  },
];
